import type { FetchError } from 'ofetch';
import { RuntimeConfig } from 'nuxt/schema';
import type { HttpClient } from '@/utils/HttpClient';

export type SearchService = {
  search: (data: object, trackingId: string) => Promise<unknown>;
  searchByAttribute: (data: object, trackingId: string) => Promise<unknown>;
  trackBehaviour: (data: object, trackingId: string) => Promise<HttpResponse<object, FetchError>>;
};

const setHeaders = (trackingId: string, config: RuntimeConfig): object => ({
  headers: {
    'Content-Type': 'application/json',
    'api-version': config.public.search.api_version,
    'user-id': trackingId,
  },
});

export const SearchService = (httpClient: HttpClient): SearchService => {
  const config = useRuntimeConfig();

  return {
    search(data, trackingId) {
      return httpClient({
        endpoint: '/search',
        method: 'POST',
        body: data,
        ...setHeaders(trackingId || 'server', config),
      });
    },
    searchByAttribute(data, trackingId) {
      return httpClient({
        endpoint: '/getEntitiesByAttribute',
        method: 'POST',
        body: data,
        ...setHeaders(trackingId || 'server', config),
      });
    },
    trackBehaviour(data, trackingId): Promise<HttpResponse<object, FetchError>> {
      return httpClient<object, FetchError>({
        endpoint: '/createEvents',
        method: 'POST',
        body: data,
        ...setHeaders(trackingId, config),
      });
    },
  };
};
